<template>
    <div>
        <!--注册的顶部导航-->
        <div class="topNav">
            <div class="sonLevel">
                <div class="sonLevelLeft">
                  <span class="vertical-middle">
<!--                      <img src="../../../assets/img/135sss.png" height="50" width="151"/>-->
                  </span>
                    <span style="font-size:25px;margin-left:20px;line-height:50px;" class="text-white vertical-middle">{{commonTitle}}</span>
                </div>
                <div class="sonLevelRight">
<!--                    <el-button  type="text">-->
<!--                        <span class="iconfont icon-xiangqingyemian-fanhuishouye text-white">-->
<!--                            <span> 返回首页</span>-->
<!--                        </span>-->
<!--                    </el-button>-->
<!--                    <el-button type="text" v-if="commonTitle==='欢迎注册'" class="margin-medium-left">-->
<!--                        <span class="text-white iconfont icon-xinshoujiaocheng">-->
<!--                             <span> 新手注册教程</span>-->
<!--                        </span>-->
<!--                    </el-button>-->
                    <el-button type="text" class="margin-medium-left">
                        <span class="text-white" @click="$router.push('/')">
                            已有账号？直接登录>
                        </span>
                    </el-button>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        name: "activationOrRegisterDashboard",
        data(){
          return{
              //设置公共title
              commonTitle:''
          }
        },
        mounted(){
            console.log('我是当前的路由');
            console.log(this.$route.path);
            if(this.$route.path==='/login/findPassword'){
                this.commonTitle='找回密码';
            }else if (this.$route.path==='/login/register'){
                this.commonTitle='欢迎注册';
            }else if(this.$route.path.indexOf('/login/cardBuy')!==-1){
                this.commonTitle='购卡页面';
            }else if(this.$route.path.indexOf('/login/cardPay')!==-1){
                this.commonTitle='确认订单';
            }else if(this.$route.path.indexOf('/login/cardBeginPay')!==-1){
                this.commonTitle='收银台';
            }else{
                this.commonTitle='欢迎激活';
            }
        }
    }
</script>
<style lang="scss" scoped>
    .topNav{
        height: 110px;
        background: #2E86FF;
        width: 100%;
        .sonLevel{
            position: relative;
            margin: 0 auto;
            width: 1000px;
            .sonLevelLeft{
                position: absolute;
                left: 0;
                top: 30px;
                height: 50px;
            }
            .sonLevelRight{
                position: absolute;
                right: 0;
                top:30px;
                height: 50px;
            }
        }
    }
</style>